import { put } from "../../../../common/api/apiShared";
import { getStartPageName, UserStartPage } from "../../../../user/User.types";
import { useTranslation } from "../../../../localization/useTranslation";
import { useState } from "react";
import { useUserContext } from "../../../../auth/userContextProvider/UserContextProvider";
import { IStartPageSelectorDialogProps } from "./StartPageSelectorDialog";
import { useDotLegalSnackbar, useStateLocalStorage, useStateSessionStorage } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalQuery, useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { useStartPage } from "../../../../user/hooks/useStartPage";

export default function useStartPageSelectorDialog(props: IStartPageSelectorDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const url = `/user/startPage`;
    const { translateString } = useTranslation();
    const { startPage } = useUserContext();
    const { isStartPageShownInMenu } = useStartPage();
    const { isLoading, data } = useDotLegalQuery<Array<UserStartPage>>(url);
    const [localStorageUserStartPage, setLocalStorageUserStartPage] = useStateLocalStorage<number | undefined>("UserStartPage", undefined);
    const [userStartPage, setUserStartPage] = useState(localStorageUserStartPage ? localStorageUserStartPage.toString() : startPage.toString());

    const saveMutation = useDotLegalMutation(save);
    const updateStartPage = () => {
        saveMutation.mutateAsync(userStartPage, {
            onSuccess: (response: any) => {
                snackbar.show(translateString("startPageUpdated"));
                setLocalStorageUserStartPage(Number(userStartPage));
                props.onDialogClose();
            },
        });
    };

    function save(startingPage: string) {
        return put<string>("/user/startpage", Number(startingPage));
    }

    function userStartPageOptions() {
        if (data) {
            return data.filter(isStartPageShownInMenu).map((x) => {
                return {
                    id: x.toString(),
                    name: getStartPageName(x, translateString),
                };
            });
        }

        return [];
    }

    return {
        userStartPageOptions: userStartPageOptions(),
        isLoading,
        userStartPage,
        setUserStartPage,
        updateStartPage,
        isSaving: saveMutation.isLoading,
    };
}
